<template>
  <div class="shelf-time">
    <el-dialog title="设置上下架时间" width="30%" :visible.sync="dialogVisible">
      <el-form label-width="100px" ref="formData" :model="formData" :rules="formDataRules">
        <el-form-item label="上架时间：" prop="addedTime">
          <el-date-picker type="datetime" v-model="formData.addedTime" placeholder="请选择" format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="下架时间：" prop="timeOff">
          <el-date-picker type="datetime" v-model="formData.timeOff" placeholder="请选择" format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
      </el-form>
      <!--      <div style="color: red;">注意事项：每日将按照设定时间，进行自动上下架所有跟卖产品。</div>-->
      <div slot="footer">
        <el-button type="primary" :loading="loadingStatus" @click="submitTime">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ShelfTime',
  data() {
    return {
      dialogVisible: false,
      formData: {
        addedTime: '',
        timeOff: '',
      },
      formDataRules: {
        addedTime: [{ required: true, message: '请选择上架时间', trigger: 'change' }],
        timeOff: [{ required: true, message: '请选择下架时间', trigger: 'change' }],
      },
      loadingStatus: false,
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.loadingStatus = false
      this.dialogVisible = false
    },
    submitTime() {
      this.$refs.formData.validate(valid => {
        if (!valid) return
        this.loadingStatus = true
        this.$emit('confirm', this.formData)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.shelf-time {
}
</style>
